import Authentication from "../Views/Authentication";
import Dashboard from "../Views/Dashboard";

export const MainRoutes = [
  { Component: Authentication, path: "/auth", exact: false },
  { Component: Dashboard, path: "/dashboard", exact: false },
];
